module.exports = __webpack_public_path__ + "media/2x/diverse-people@2x-a524449e.png";